import { POIGalleryDeveloperSticky } from './poi-gallery-developer-sticky';

export default POIGalleryDeveloperSticky;
